import {debounce} from "../lib";

import $ from 'jquery';
import select2 from "select2";

select2();

export class DataFilters {
    constructor(reloadData, versionName) {
        this.reloadData = reloadData;
        this.versionName = versionName;
    }

    init() {
        this.initFilterPreferences();
        this.initMatchFilters();
        this.initContainsFilters();
        this.initRelatedDatasetFilters();
        this.initVersionFilter();
        this.initInputListeners();
        this.showHideAdditionalFilters();
    }

    /**
     * Initialises select2 dropdowns for `match` filters.
     * Enables users to select one or more values, which are loaded from the API when the dropdown list is expanded.
     * Existing filter values are parsed from the URL and prepopulated in the dropdown.
     * Whenever the selection changes, the URL is updated to reflect the current filter state,
     * using `__or__` to join multiple values under the same parameter name.
     */
    initMatchFilters() {
        let self = this;
        $('.match-filter').each(function () {
            let name = $(this).attr("name")
            const select2Element = $(this).select2({
                placeholder: "Please select",
                width: "100%",
                theme: "bootstrap-5",
                ajax: {
                    url: function () {
                        const apiV2Url = new URL($('#api_v2_url').attr('href'), window.location.origin);

                        // Exclude the current field's filter to avoid self-filtering
                        apiV2Url.searchParams.delete(name);

                        // Build the base distinct field endpoint
                        const datasetSlug = $(this).attr("data-slug");
                        const fieldSlug = $(this).attr("data-field-slug");
                        const apiBase = `/api/v2/datasets/${datasetSlug}/distinct/${fieldSlug}/`;

                        // Append all remaining filters as query params
                        const finalUrl = new URL(apiBase, window.location.origin);
                        apiV2Url.searchParams.forEach((value, key) => {
                            finalUrl.searchParams.append(key, value);
                        });

                        return finalUrl.toString();
                    },

                    delay: 250,
                    data: function (params) {
                        let query = {};
                        query.contains = params.term;
                        query.page = !params.page ? 1 : params.page;
                        return query;
                    },
                    processResults: function (data) {
                        const results = data.results.map(value => ({
                            id: value,
                            text: value
                        }));
                        return {
                            results: results,
                            pagination: {
                                more: data.next !== null
                            }
                        };
                    }
                }
            });
            // prepopulate selected values from URL
            const values = self.getFilterValuesFromURL(name);
            values.forEach(function (value) {
                const option = new Option(value, value, true, true);
                select2Element.append(option).trigger("change");
            });


            $(this).on('change', () => {
                const selectedValues = $(this).val();
                self.updateFilterURLParam(name, selectedValues);
            });
        });
    }


    /**
     * Initialises select2 dropdowns for `contains` filters.
     * Enables users to enter one or more values by typing and pressing Enter.
     * Existing filter values are parsed from the URL and prepopulated in the dropdown.
     * Whenever the selection changes, the URL is updated to reflect the current filter state,
     * using `__or__` to join multiple values under the same parameter name.
     */
    initContainsFilters() {
        let self = this;
        $('.contains-filter').each(function () {
            let name = $(this).attr("name")
            $(this).select2({
                tags: true,
                tokenSeparators: [],
                placeholder: '',
                width: "100%",
                theme: "bootstrap-5",
                language: {
                    noResults: function () {
                        return 'Type a value and press Enter to add it as a filter.'
                    },
                },
                createTag: (params) => {
                    const term = params.term;
                    if (term === '') return null;
                    return {
                        id: term,
                        text: term,
                        newTag: true
                    };
                }
            });

            // prepopulate selected values from URL
            const values = self.getFilterValuesFromURL(name);

            values.forEach(val => {
                if (!$(this).find(`option[value="${val}"]`).length) {
                    $(this).append(new Option(val, val, true, true));
                }
            });
            $(this).val(values).trigger('change');
            $(this).on('change', () => {
                const selectedValues = $(this).val();
                self.updateFilterURLParam(name, selectedValues);
            });
        });
    };


    initRelatedDatasetFilters() {
        $(".related-dataset-filter").each(function () {
            const url =
                "/api/v2/dataset/" + $(this).attr("data-related-slug") + "/";
            const fieldName = $(this).attr("data-schema-name");

            const select2Element = $(this).select2({
                placeholder: "Please select",
                width: "100%",
                theme: "bootstrap-5",

                ajax: {
                    url,
                    delay: 250,
                    data: function (params) {
                        let query = {};
                        const val = $(this)
                            .attr("name")
                            .replace("__in", "__contains")
                            .split("__");
                        const lookup = val.splice(1, val.length).join("__");
                        query[lookup] = params.term;
                        query.page = !params.page ? 1 : params.page;
                        query.limit_choices_to = $(
                            'input[name="limit_choices_to"]'
                        ).val();
                        query.limit_choices_field = $(this).data(
                            "limit-choices-field"
                        );
                        query.ordering = fieldName;
                        return query;
                    },
                    processResults: function (data) {
                        var selectData = [];
                        data.results.forEach(function (result) {
                            const row = {
                                id: result[fieldName],
                                text: result[fieldName],
                            };
                            selectData.push(row);
                        });
                        return {
                            results: selectData,
                            pagination: {
                                more: data.next !== null,
                            },
                        };
                    },
                },
            });
            const params = new URLSearchParams(window.location.search);
            const values = params.getAll($(this).prop("name"));
            values.forEach(function (value) {
                const option = new Option(value, value, true, true);
                select2Element.append(option).trigger("change");
            });
        });
    }

    /**
     * This function initialises the select2 element responsible for adding a version filter.
     * When the user expands the filter dropdown list, it makes a request to the version endpoint to retrieve the list
     * of filters for this dataset.
     * It also creates a dummy option representing the current selection.
     */
    initVersionFilter() {
        let self = this;
        $(".version-filter").each(function () {
            const url =
                "/api/v2/dataset/" + $(this).attr("data-slug") + "/versions/";
            const select2Element = $(this).select2({
                placeholder: "Please select",
                width: "80%",
                theme: "bootstrap-5",

                ajax: {
                    url,
                    delay: 250,
                    processResults: function (data) {
                        var selectData = [];
                        data.results.forEach(function (result) {
                            const row = {
                                id: result['slug'],
                                text: result['name'],
                            };
                            selectData.push(row);
                        });
                        return {
                            results: selectData,
                            pagination: {
                                more: data.next !== null,
                            },
                        };
                    },
                },
            });
            const params = new URLSearchParams(window.location.search)
            const versionSelection = params.get('version')
            const option = $("<option selected></option>").val(versionSelection).text(self.versionName);
            select2Element.append(option).trigger("change.select2")
        });
    }

    initFilterPreferences() {
        this.getFilterPreferences("");
        $(document).on(
            "click",
            "#submit-id-add",
            function (e) {
                e.preventDefault();
                const field = $("#id_add_filter").val();
                this.getFilterPreferences(field + "/");
            }.bind(this)
        );

        $(document).on(
            "click",
            ".delete-filter",
            function (e) {
                e.preventDefault();
                const field = $(e.target).closest(".col-md-3").attr("id");
                this.removeFilter(field);
            }.bind(this)
        );
    }

    initInputListeners() {
        let timeoutId;
        $("#filter-form :input:not(#id_add_filter)").on(
            "input",
            function (event) {
                const type = $(event.target).attr("type");
                const applyDebounce = [
                    "text",
                    "number",
                    "date",
                    "datetime-local",
                    "month",
                    "week",
                    "time",
                ].includes(type);
                const action = applyDebounce
                    ? debounce(this.reloadData, 500)
                    : this.reloadData;
                if (!applyDebounce) {
                    return action();
                }
                if (timeoutId) {
                    clearTimeout(timeoutId);
                }
                // Set a new timeout
                timeoutId = setTimeout(action, 500);
            }.bind(this)
        );
    }

    /**
     * This function iterates over an array of fields, removing the 'd-none' class and showing each field's filter.
     * It also disables the option in the 'id_add_filter' select element that corresponds to each field.
     *
     * @param {string[]} fields - Array containing field lookup names.
     */
    showFilters(fields) {
        for (const field of fields) {
            $("#" + field)
                .removeClass("d-none")
                .show();
            $("#id_add_filter>option[value=" + field + "]").prop(
                "disabled",
                true
            );
        }
    }

    /**
     * This function sends a POST request to the server to get the fields stored in filter preferences.
     * If a field lookup name is passed into the function, this field will first be added to the filter preferences.
     * On success, it passes the array of fields into the showFilters function.
     *
     * @param {string} field - The lookup name of the field to add to the filter preferences.
     */
    getFilterPreferences(field) {
        $.ajax({
            url: DataPage.urls.filterPreferenceUrl + field,
            type: "POST",
            data: {
                csrfmiddlewaretoken: document.querySelector(
                    'input[name="csrfmiddlewaretoken"]'
                ).value,
            },
            success: function (data) {
                this.showFilters(data);
            }.bind(this),
        });
    }

    /**
     * This function removes a filter from the UI and the URL parameters.
     * It sends a POST request to the server to delete the filter preference for a specific field.
     * It then hides the field in the UI and enables the option in the 'id_add_filter' select element that corresponds to the field.
     * It also removes the field from the URL parameters and reloads the page with the updated URL.
     *
     * @param {string} field - The lookup name of the field for which to remove the filter.
     */
    removeFilter(field) {
        // Send a POST request to the server to delete the filter preference for the field
        $.ajax({
            url: DataPage.urls.filterPreferenceUrl + field + "/delete/",
            type: "POST",
            data: {
                csrfmiddlewaretoken: document.querySelector(
                    'input[name="csrfmiddlewaretoken"]'
                ).value,
            },
        });

        // Hide the field in the UI
        $("#" + field).hide();

        // Enable the option in the 'id_add_filter' select element that corresponds to the field
        $("#id_add_filter>option[value=" + field + "]").prop(
            "disabled",
            false
        );

        // Create a new URL object from the current URL
        const url = new URL(document.URL);
        let urlParams = url.searchParams;

        // Iterate over the URL parameters
        for (let param of urlParams) {
            // If the parameter name starts with the field lookup name, set the parameter value to an empty string
            if (
                param[0] === field ||
                param[0].startsWith(field + "__")
            ) {
                urlParams.set(param[0], "");
            }
        }

        // Reload the page with the updated URL
        window.location.href = `?${urlParams.toString()}`;
    }


    /**
     * Toggles the visibility of the additional filters based on the state of corresponding checkboxes.
     * When a checkbox with an id starting with 'additional-filter-checkbox-' is checked or unchecked,
     * it shows or hides the related exclusion filter divs.
     */
    showHideAdditionalFilters() {
        const checkboxes = document.querySelectorAll('input[id^="additional-filter-checkbox-"]');

        checkboxes.forEach((checkbox) => {
            checkbox.addEventListener('change', function () {
                const lookupName = this.id.replace('additional-filter-checkbox-', '');

                // Find all field divs with IDs containing this lookup name and ending in __exclude
                const excludeDivs = document.querySelectorAll(`[id^="div_id_${lookupName}__"][id$="__exclude"]`);

                excludeDivs.forEach(div => {
                    // Most of these are wrapped in a .d-none div, so we want to toggle the parent
                    const wrapper = div.closest('.d-none') || div;
                    if (this.checked) {
                        wrapper.classList.remove('d-none');
                    } else {
                        wrapper.classList.add('d-none');
                    }
                });
            });
        });
    }

    /**
     * Parses the URL to get values for a given filter parameter.
     *
     * @param {string} paramName - The filter parameter name to retrieve from the URL.
     * @returns {Array} - Array of filter values.
     */
    getFilterValuesFromURL(paramName) {
        const params = new URLSearchParams(window.location.search);
        const rawParam = params.get(paramName);
        return rawParam ? rawParam.split('__or__').filter(Boolean) : [];
    }

    /**
     * Updates the current URL with new filter values under the specified parameter.
     * Values are joined with '__or__' to allow multiple selections.
     *
     * @param {string} name - The filter parameter name to update in the URL.
     * @param {Array} selectedValues - Array of selected filter values.
     */
    updateFilterURLParam(name, selectedValues) {
        const params = new URLSearchParams(window.location.search);
        params.set(name, selectedValues.join('__or__'));
        const newUrl = `${window.location.pathname}?${params.toString()}`;
        window.history.replaceState({}, '', newUrl);
    }

}

export default class DataPage {
    static urls = {};
    static columns = [];

    constructor(requestData) {
        this.requestData = requestData;
    }

    ready() {
        this.filters = new DataFilters(this.reload.bind(this), this.requestData.versionName);
        this.filters.init();
        this.expandFilters();
        this.datatable = $("#datatable").DataTable({
            serverSide: true,
            searching: false,
            pagingType: "simple_numbers",
            scrollX: true,
            fixedHeader: true,
            stateSave: true,
            processing: true,
            language: {
                processing:
                    '<i class="fa fa-spin fa-3x fa-fw"></i><span class="sr-only">Loading...</span>',
            },
            order: [[this.requestData.order, this.requestData.direction]],
            displayStart: this.requestData.displayStart,
            pageLength: this.requestData.pageLength,
            stateSaveCallback: function (settings, currentState) {
                const newParams = {
                    start: currentState.start,
                    length: currentState.length,
                    order: currentState.order[0][0],
                    direction: currentState.order[0][1],
                };
                const params = this.getAPIParams();
                for (let [key, val] of Object.entries(newParams)) {
                    params.set(key, val);
                }
                this.deleteDataTablesParams(params);
                window.history.replaceState(
                    null,
                    null,
                    `?${params.toString()}`
                );
                this.updatePageLinks();
            }.bind(this),
            ajax: {
                url: this.getAPIURL(this.getAPIParams()),
                data: function (d) {
                    // cleans up the search object to remove empty values
                    // when datasets have many columns, these search values cause nginx to return a 414 error
                    d.columns = d.columns.filter((c) => c.search.value !== "");
                    return d

                }
            },
            columns: DataPage.columns,
            rowCallback: function (row, data) {
                if (data.status === "draft") {
                    $(row).addClass("object-in-draft");
                }
                if (data.marked_for_deletion) {
                    $(row).addClass("object-marked-for-deletion");
                }
            },
        });
        $("#only_new_or_changed_check").change(this.reload.bind(this));
    }

    /**
     * Collects and formats filter form data for the API request.
     * Combines multi-value filters using '__or__' and removes empty or irrelevant fields.
     * Returns a URLSearchParams object.
     */
    getAPIParams() {
        const $form = $("#filter-form");
        const data = new URLSearchParams($form.serialize());

        // Combine match or contains values using __or__
        $form.find(".match-filter,  .contains-filter").each(function () {
            const name = $(this).attr("name");
            const values = $(this).val();

            if (values && values.length > 0) {
                data.delete(name);
                data.set(name, values.join('__or__'));
            }
        });

        data.delete("csrfmiddlewaretoken");
        data.set("format", "datatables");
        data.set("status", this.requestData.status);
        data.set(
            "show_changed_only",
            $("#only_new_or_changed_check").is(":checked") ? "1" : "0"
        );
        data.deleteEmpty();
        return data;
    }

    /**
     * Displays additional filter fields in use when the page is loaded. * Also ensures the corresponding checkbox is checked.
     */
    expandFilters() {
        const data = this.getAPIParams();

        for (const [key, value] of data.entries()) {
            // Only process keys that end with "__exclude" and have a non-empty value
            if (key.endsWith("__exclude") && value.trim() !== "") {
                // Extract the lookup name before the final "__exclude"
                const lookupName = key.replace(/__[^_]+__exclude$/, '');

                // Show all related exclude fields for this lookupName
                const excludeFields = document.querySelectorAll(`[id^="div_id_${lookupName}__"]`);

                excludeFields.forEach(field => {
                    const wrapper = field.closest('.d-none') || field;
                    wrapper.classList.remove('d-none');
                });
                // Ensure the associated checkbox is selected
                const excludeCheckbox = document.getElementById(`additional-filter-checkbox-${lookupName}`);
                if (excludeCheckbox) {
                    excludeCheckbox.checked = true;
                }
            }
        }
    }


    getAPIURL(params) {
        return this.parseAPIURL(DataPage.urls.apiV2Url, params);
    }

    reload() {
        const params = this.getAPIParams();
        this.datatable.ajax.url(this.getAPIURL(params));
        this.datatable.ajax.reload();
    }

    updatePageLinks() {
        const params = this.getAPIParams();
        this.deleteDataTablesParams(params);
        // important this happens AFTER we delete the data table parameters
        // this hides some of the hidden helper fields from the URL
        // making the URL more readable
        this.updatePageLink("#api_v1_url", params, true);
        this.updatePageLink("#api_v2_url", params, true);

        const exportParams = new URLSearchParams();
        exportParams.set("from", "ui");
        exportParams.set("params", params.toString());
        this.updatePageLink("#export-link", exportParams);

        const toggleDraftParams = new URLSearchParams(params.toString());
        toggleDraftParams.set(
            "status",
            this.requestData.status == "published" ? "draft" : "published"
        );
        this.updatePageLink("#toggle-draft-published", toggleDraftParams);
    }

    updatePageLink(id, params, updateText) {
        const linkElement = $(id);
        if (!linkElement.length) {
            return;
        }
        const href = linkElement.prop("href");
        const newHref = this.parseAPIURL(href, params);
        linkElement.prop("href", newHref);
        if (updateText) {
            linkElement.text(newHref);
        }
    }

    /**
     * This function takes a URL and a data object, and returns a new URL with the data object serialized as query parameters.
     * The original query parameters of the URL are discarded.
     *
     * @param {string} url - The original URL.
     * @param {Object} data - The data object to be serialized as query parameters.
     * @returns {string} - The new URL with the data object serialized as query parameters.
     */
    parseAPIURL(url, data) {
        return url.split("?")[0] + "?" + data.toString();
    }

    /**
     * deletes parameters that are only required by data tables
     * @param {URLSearchParams} params
     */
    deleteDataTablesParams(params) {
        params.deleteMany([
            "format",
            "limit_choices_to",
            "limit_choices_field",
        ]);
    }
}
